export default __webpack_public_path__ + "static/media/16_KoninklijkCircus_17_DSC09329_KristofVadino-min.8fa83edd.jpg";